import { ChangeEvent, useState } from 'react';
import { ControllerRenderProps } from 'react-hook-form';
import { FieldFactory } from '../../../../../components/Form/FieldFactory';
import { KpiSection } from '../../../../../data-models/company-financials.data-model';
import { field2ToFormField } from '../../../../../data-models/field2.data-model';
import {
  IKPIDataValue,
  IKPIRequestResponse,
  KPIRequestFrequency,
} from '../../../../../data-models/kpi-requests.data-model';
import {
  IKPITemplateSectionDataModel,
  ITextualKpiTemplateSectionMeta,
} from '../../../../../data-models/kpi-template.data-model';
import { IFormFieldTextMeta } from '../../../../../view-models/form.view-model';
import { getNextKpiPeriod } from '../../../utils';

export interface ITextualKpiFieldProps {
  kpiRequestFrequency: KPIRequestFrequency;
  period: string; // iso date, e.g. 2025-01-01
  section: IKPITemplateSectionDataModel;
  onChange: (data: IKPIDataValue) => void | Promise<void>;
  disabled?: boolean;
  response: IKPIRequestResponse;
  rendererMeta?: IFormFieldTextMeta;
}

export function TextualKpiField({
  section,
  kpiRequestFrequency,
  period,
  onChange,
  disabled,
  response,
  rendererMeta = {},
}: ITextualKpiFieldProps) {
  const sectionMeta = section.meta as ITextualKpiTemplateSectionMeta;
  const date =
    sectionMeta.section === KpiSection.budget
      ? getNextKpiPeriod(period, kpiRequestFrequency).toString()
      : period;

  const [currValue, setCurrValue] = useState(
    () =>
      // there will be only one date for textual kpis, corresponding to request.period
      response.kpiData.values?.find(
        (kpi) => kpi.kpiId === sectionMeta?.kpiConfig.id && kpi.section === sectionMeta?.section
      )?.value ?? null
  );

  const formField = {
    ...field2ToFormField(sectionMeta.kpiConfig),
    disabled,
    rendererMeta: {
      multiline: true,
      rows: 3,
      ...rendererMeta,
    },
  };
  const formProps = {
    onChange: (event: ChangeEvent<HTMLInputElement>) => {
      setCurrValue(event.target.value);
      onChange({
        kpiId: sectionMeta.kpiConfig.id,
        section: sectionMeta.section,
        date,
        value: event.target.value,
      });
    },
    value: currValue,
  } as ControllerRenderProps;

  return <FieldFactory formField={formField} formProps={formProps} />;
}
